export const downloadFile = (data: Blob, exportType: string, filename: string) => {
  const blob = new Blob([data], { type: data.type ?? `text/${exportType}` });
  const url = globalThis.URL.createObjectURL(blob);
  const a = document.createElement('a');
  const fileName = filename.includes('./customers') ? filename : `${filename}.${exportType}`;
  a.setAttribute('href', url);
  a.setAttribute('download', fileName);
  a.click();
};
